import { useContext } from "react";
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";

export const useShowRealProperty = () => { // SHOW REAL PROPERTY FOR i4ONE & MR
	const { tool_state } = useContext(ToolContext)
	const companyId = tool_state.__SESSION?.data?.uaccess?.[0]?.company_id
	const allowedCompanies = [1371, 2001] // must be company_id in prod of i4one and MR respectively
	const testingCompanyId = [1729,2158]
	const isAllowed = env() === 'prod' ? allowedCompanies.includes(companyId) : testingCompanyId.includes(companyId)
	// if (env() !== 'prod') return true;

  	return isAllowed;
}
